import { Component } from "react";

import { Form, Col, Row } from "react-bootstrap";

import { PhoneInput } from "react-international-phone";

import GenerationsSelect from "../../../layout/select/generation";
import Address from "../../../layout/address";
import { deepEqual } from "../../../utils/object";

class Personal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.stateFromProps(props),
            loading: true
        };
    }

    stateFromProps = (props) => {
        const { displayName, firstName, middleName, lastName, generation, email, Residence, phone, fax, ssn, defaultCountry, company, Company, userUuid, archive } = props;
        return {
            displayName,
            firstName,
            middleName,
            lastName,
            generation,
            email,
            Residence,
            phone,
            fax,
            ssn,
            defaultCountry,
            company,
            userUuid,
            archive,
            dba: props.dba ?? Company?.dba,
            taxIdNumber: props.taxIdNumber ?? Company?.taxIdNumber
        }
    }

    componentDidUpdate(prevProps) {
        // Only compare the subset of props that actually map into state
        const prevSlice = this.stateFromProps(prevProps);
        const nextSlice = this.stateFromProps(this.props);

        if (deepEqual(prevSlice, nextSlice)) return;

        // If parent truly changed the data, sync it into state
        this.setState(nextSlice);
    }

    componentDidMount = () => {
        this.setState({ loading: false });
    }

    doPostChange = () => {
        if (this.props.onChange && !this.state.loading) {
            this.props.onChange(this.state);
        }
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, this.doPostChange);
    }

    onAddressChange = (objectName, values) => {
        this.onChange({
            target: {
                name: objectName,
                value: {
                    ...values
                }
            }
        });
    }

    onGenerationChange = (e) => {
        this.onChange({ target: { name: "generation", value: e.value } });
    }

    toSSNDigits = (value) => String(value ?? "").replace(/\D/g, "").slice(0, 9);

    toDashedSSN = (digits9) => {
        const d = this.toSSNDigits(digits9);
        const a = d.slice(0, 3);
        const b = d.slice(3, 5);
        const c = d.slice(5, 9);
        if (d.length <= 3) return a;
        if (d.length <= 5) return `${a}-${b}`;
        return `${a}-${b}-${c}`; // length 11 when complete
    };

    ssnDisplayValue = () => {
        const dashed = this.toDashedSSN(this.state.ssn || "");
        return dashed;
    };

    onSSNChange = (e) => {
        const digits = this.toSSNDigits(e.target.value);
        this.setState({ ssn: digits }, this.doPostChange);
    };

    toEINDigits = (value) => String(value ?? "").replace(/\D/g, "").slice(0, 9);

    toDashedEIN = (value) => {
        const digits = this.toEINDigits(value);
        if (digits.length <= 2) return digits;
        return `${digits.slice(0, 2)}-${digits.slice(2, 9)}`;
    };

    einDisplayValue = () => this.toDashedEIN(this.state.taxIdNumber || "");

    onEINChange = (e) => {
        const digits = this.toEINDigits(e.target.value);
        this.setState({ taxIdNumber: digits }, this.doPostChange);
    };

    render() {
        const defaultCountry = this.state.defaultCountry || "us";

        if (this.props.company) {
            return (
                <>
                    <Col xs="12">
                        <Row>
                            <Col lg="12">
                                <Row className="g-3">
                                    <Col lg="12">
                                        <h2 className="small-title">Company Information</h2>
                                    </Col>
                                </Row>
                                <Row className="g-3">
                                    <Col lg="12">
                                        <div className="mb-3 top-label">
                                            <Form.Control type="text" name="displayName" value={this.state.displayName || ""} onChange={this.onChange} />
                                            <Form.Label>DISPLAY NAME</Form.Label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="g-3">
                                    <Col md="8">
                                        <div className="mb-3 top-label">
                                            <Form.Control type="text" name="dba" value={this.state.dba || ""} onChange={this.onChange} />
                                            <Form.Label>DBA</Form.Label>
                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="mb-3 top-label">
                                            <Form.Control
                                                type="text"
                                                name="taxIdNumber"
                                                autoComplete="off"
                                                inputMode="numeric"
                                                placeholder="__-_______"
                                                value={this.einDisplayValue()}
                                                onChange={this.onEINChange}
                                            />
                                            <Form.Label>EIN</Form.Label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="g-3">
                                    <Col lg="12">
                                        <div className="mb-3 top-label">
                                            <Form.Control type="text" name="email" value={this.state.email || ""} onChange={this.onChange} />
                                            <Form.Label>EMAIL ADDRESS</Form.Label>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row className="g-3">
                            <Col lg="12">
                                <h2 className="small-title">Address</h2>
                            </Col>
                        </Row>

                        <Address {...this.state?.Residence} onChange={(values) => this.onAddressChange("Residence", values)} />

                        <Row className="g-3">
                            <Col md="6" lg="4" xxl="3"><h2 className="small-title">Phone #</h2>
                                <div className="mb-3">
                                    <PhoneInput name="phone" id="phone" defaultCountry={defaultCountry} value={this.state.phone || ""} onChange={(value) => this.onChange({
                                        target: {
                                            name: "phone",
                                            value
                                        }
                                    })} />
                                </div>
                            </Col>
                            <Col md="6" lg="4" xxl="3"><h2 className="small-title">Fax #</h2>
                                <div className="mb-3 top-label">
                                    <PhoneInput name="fax" id="fax" defaultCountry={defaultCountry} value={this.state.fax || ""} onChange={(value) => this.onChange({
                                        target: {
                                            name: "fax",
                                            value
                                        }
                                    })} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </>
            );
        }

        return (
            <>
                <Col xs="12">
                    <Row>
                        <Col lg="12">
                            <Row className="g-3">
                                <Col lg="12">
                                    <h2 className="small-title">Personal Information
                                        {this.state.userUuid ?
                                            <a
                                                href={`/dashboard/users/${this.state.userUuid}`}
                                                className={`badge rounded-pill bg-success`}
                                                style={{ marginLeft: "5px" }}>
                                                User
                                            </a>
                                            : ``}
                                        {Number(this.state.archive) > 0 ? (
                                            <button
                                                type="button"
                                                className="badge rounded-pill bg-warning text-dark border-0 ms-2"
                                                onClick={() => this.props.onUnarchive?.()}
                                                title="Unarchive person"
                                            >
                                                Archived
                                            </button>
                                        ) : null}
                                    </h2>
                                </Col>
                            </Row>
                            <Row className="g-3">
                                <Col lg="4">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="firstName" value={this.state.firstName || ""} onChange={this.onChange} />
                                        <Form.Label>FIRST NAME</Form.Label>
                                    </div>
                                </Col>
                                <Col lg="2">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="middleName" value={this.state.middleName || ""} onChange={this.onChange} />
                                        <Form.Label>MIDDLE NAME</Form.Label>
                                    </div>
                                </Col>
                                <Col lg="4">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="lastName" value={this.state.lastName || ""} onChange={this.onChange} />
                                        <Form.Label>LAST NAME</Form.Label>
                                    </div>
                                </Col>
                                <Col lg="2">
                                    <div className="mb-3 top-label">
                                        <GenerationsSelect value={this.state.generation || ""} onChange={this.onGenerationChange} placeholder="" name="generation" />
                                        <Form.Label>SUFFIX</Form.Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="g-3">
                                <Col lg="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="email" value={this.state.email || ""} onChange={this.onChange} />
                                        <Form.Label>EMAIL ADDRESS</Form.Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="g-3">
                                <Col md="6" lg="4">
                                    <div className="mb-3 top-label">
                                        <Form.Control
                                            type="text"
                                            name="ssn"
                                            autoComplete="off"
                                            inputMode="numeric"
                                            placeholder="___-__-____"
                                            value={this.ssnDisplayValue()}
                                            onChange={this.onSSNChange}
                                        />
                                        <Form.Label>SOCIAL SECURITY #</Form.Label>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row className="g-3">
                        <Col lg="12">
                            <h2 className="small-title">Address</h2>
                        </Col>
                    </Row>
                
                    <Address {...this.state?.Residence} onChange={(values) => this.onAddressChange("Residence", values)} />
                
                    <Row className="g-3">
                        <Col md="6" lg="4" xxl="3"><h2 className="small-title">Phone #</h2>
                            <div className="mb-3">
                                <PhoneInput name="phone" id="phone" defaultCountry={this.defaultCountry} value={this.state.phone || ""} onChange={(value) => this.onChange({
                                    target: {
                                        name: "phone",
                                        value
                                    }
                                })} />
                            </div>
                        </Col>
                        <Col md="6" lg="4" xxl="3"><h2 className="small-title">Fax #</h2>
                            <div className="mb-3 top-label">
                                <PhoneInput name="fax" id="fax" defaultCountry={this.defaultCountry} value={this.state.fax || ""} onChange={(value) => this.onChange({
                                    target: {
                                        name: "fax",
                                        value
                                    }
                                })} />
                            </div>
                        </Col>

                    </Row>
                </Col>
            </>
        )
    }
}

export default Personal;
